import React from "react";
import SimpleTextInput from "../../../../../../Components/SimpleTextInput/SimpleTextInput";
import Separator from "../../../../../../Components/Separator/Separator";
import SimplePasswordInput from "../../../../../../Components/SimpleTextInput/SimplePasswordInput";
import ChangePasswordModal from "../../../../../../Components/ChangePasswordModal/ChangePasswordModal";
import call from "../../../../../../API/API";
import "./AccountForm.css";

class AccountForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        name: "",
        lastname: "",
        email: "",
        password: "",
      },
      defaultValues: {
        name: "",
        lastname: "",
        email: "",
        password: "",
      },
      isLoading: true,
      showChangePasswordModal: false,
    };

    this.handleNameOnChange = this.handleNameOnChange.bind(this);
    this.handleOnAcceptName = this.handleOnAcceptName.bind(this);
    this.handleOnCancelName = this.handleOnCancelName.bind(this);
    this.handleLastNameOnChange = this.handleLastNameOnChange.bind(this);
    this.handleOnAcceptLastName = this.handleOnAcceptLastName.bind(this);
    this.handleOnCancelLastName = this.handleOnCancelLastName.bind(this);

    this.handleEmailOnChange = this.handleEmailOnChange.bind(this);
    this.handleOnAcceptEmail = this.handleOnAcceptEmail.bind(this);
    this.handleOnCancelEmail = this.handleOnCancelEmail.bind(this);

    this.handlePasswordButtonOnClick = this.handlePasswordButtonOnClick.bind(
      this
    );
    this.handlePasswordModalOnClose = this.handlePasswordModalOnClose.bind(
      this
    );
  }

  componentDidMount() {
    call.users_API.getPersonalUserMatchingCriteria().then((result) => {
      if (result.success === true) {
        this.setState({
          user: {
            name: result.results.name,
            lastname: result.results.lastname,
            email: result.results.email,
            password: "",
          },
          defaultValues: {
            name: result.results.name,
            lastname: result.results.lastname,
            email: result.results.email,
            password: "",
          },
        });
      }
    });
  }

  handlePasswordButtonOnClick() {
    this.setState({
      showChangePasswordModal: true,
    });
  }

  handlePasswordModalOnClose() {
    this.setState({
      showChangePasswordModal: false,
    });
  }

  handleNameOnChange(e) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        name: e.target.value,
      },
    }));
  }

  handleLastNameOnChange(e) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        lastname: e.target.value,
      },
    }));
  }

  handleEmailOnChange(e) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        email: e.target.value,
      },
    }));
  }

  // handlePasswordOnChange(e) {
  //   this.setState((prevState) => ({
  //     user: {
  //       ...prevState.user,
  //       password: e.target.value,
  //     },
  //   }));
  // }

  handleOnAcceptName() {
    let name = this.state.user.name;
    let defaultName = this.state.defaultValues.name;
    call.users_API
      .updateUser({ name: name })
      .then((result) => {
        if (result.success) {
          this.props.showSuccessBox("Success", "The new name has been saved.");
          this.setState(
            (prevState) => ({
              defaultValues: {
                ...prevState.defaultValues,
                name: name,
              },
            }),
            () => {
              this.props.handleNameUpdate(name);
            }
          );
        } else {
          this.props.showErrorBox(
            "Error",
            "Name changes could not be changed. Please try again."
          );
          this.setState((prevState) => ({
            user: {
              ...prevState.user,
              name: defaultName,
            },
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleOnAcceptLastName() {
    let lastname = this.state.user.lastname;
    let defaultLastName = this.state.defaultValues.lastname;
    call.users_API
      .updateUser({ lastname: lastname })
      .then((result) => {
        if (result.success) {
          this.props.showSuccessBox("Success", "The new lastname is saved.");
          this.setState(
            (prevState) => ({
              defaultValues: {
                ...prevState.defaultValues,
                lastname: lastname,
              },
            }),
            () => {
              this.props.handleLastNameUpdate(lastname);
            }
          );
        } else {
          this.props.showErrorBox(
            "Error",
            "Lastname changes could not be saved. Please try again."
          );
          this.setState((prevState) => ({
            user: {
              ...prevState.user,
              lastname: defaultLastName,
            },
          }));
        }
      })
      .catch((err) => console.log(err));
  }

  handleOnAcceptEmail() {
    let email = this.state.user.email;
    let defaultEmail = this.state.defaultValues.email;
    call.users_API
      .updateUser({ email: email })
      .then((result) => {
        if (result.success) {
          this.props.showSuccessBox("Success", "The new email is saved.");
          this.setState((prevState) => ({
            defaultValues: {
              ...prevState.defaultValues,
              email: email,
            },
          }));
        } else {
          this.props.showErrorBox(
            "Error",
            "Email changes could not be saved. Please try again."
          );
          this.setState((prevState) => ({
            user: {
              ...prevState.user,
              email: defaultEmail,
            },
          }));
        }
      })
      .catch((err) => console.log(err));
  }

  // handleOnAcceptPassword() {
  //   let password = this.state.user.password;
  //   if (password !== "") {
  //     call.users_API
  //       .updateUser({ password: password })
  //       .then((result) => {
  //         if (result) {
  //           this.props.showSuccessBox("Success", "The new password is saved.");
  //           this.setState((prevState) => ({
  //             user: {
  //               ...prevState.user,
  //               password: "",
  //             },
  //           }));
  //         } else {
  //           this.props.showErrorBox(
  //             "Error",
  //             "Password changes could not be saved. Please try again."
  //           );
  //           this.setState((prevState) => ({
  //             user: {
  //               ...prevState.user,
  //               password: "",
  //             },
  //           }));
  //         }
  //       })
  //       .catch((err) => console.log(err));
  //   } else {
  //     this.props.showErrorBox("Error", "Password should not be empty.");
  //   }
  // }

  handleOnCancelName() {
    let defaultName = this.state.defaultValues.name;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        name: defaultName,
      },
    }));
  }

  handleOnCancelLastName() {
    let defaultLastName = this.state.defaultValues.lastname;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        lastname: defaultLastName,
      },
    }));
  }

  handleOnCancelEmail() {
    let defaultEmail = this.state.defaultValues.email;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        email: defaultEmail,
      },
    }));
  }

  // handleOnCancelPassword() {
  //   this.setState((prevState) => ({
  //     user: {
  //       ...prevState.user,
  //       password: "",
  //     },
  //   }));
  // }

  render() {
    return (
      <React.Fragment>
        <section className="form account-form">
          <div className="account-form-row">
            <SimpleTextInput
              id="user-name"
              label="First name"
              placeholder="John"
              type="text"
              value={this.state.user.name}
              isPassword={false}
              handleOnAccept={this.handleOnAcceptName}
              handleOnCancel={this.handleOnCancelName}
              handleTextInputOnChange={this.handleNameOnChange}
            />
          </div>
          <Separator />
          <div className="account-form-row">
            <SimpleTextInput
              id="user-last-name"
              label="Last name"
              placeholder="Doe"
              type="text"
              value={this.state.user.lastname}
              isPassword={false}
              handleTextInputOnChange={this.handleLastNameOnChange}
              handleOnAccept={this.handleOnAcceptLastName}
              handleOnCancel={this.handleOnCancelLastName}
            />
          </div>
          <Separator />
          <div className="account-form-row">
            <SimpleTextInput
              id="user-email"
              label="Email"
              placeholder="john.doe@domain.com"
              type="email"
              value={this.state.user.email}
              isPassword={false}
              handleTextInputOnChange={this.handleEmailOnChange}
              handleOnAccept={this.handleOnAcceptEmail}
              handleOnCancel={this.handleOnCancelEmail}
            />
          </div>
          <Separator />
          <div className="account-form-row">
            <SimplePasswordInput
              id="user-password"
              label="Password"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              type="password"
              value={this.state.user.password}
              isPassword={true}
              handlePasswordButtonOnClick={this.handlePasswordButtonOnClick}
            />
          </div>
        </section>
        {this.state.showChangePasswordModal ? (
          <ChangePasswordModal
            handleModalOnClose={this.handlePasswordModalOnClose}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default AccountForm;
